import { TThunkAction } from '../../types/redux';

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

interface IViewData {
  headingType: string;
}

export interface IRequestAuthenticationParameters {
  viewData?: IViewData;
  source?: string;
  alert?: EAlertType;
  onSuccess?(): TThunkAction;
  onCloseNoAuth?(): TThunkAction;
}

export interface IAuthenticateEvent {
  autoRefresh?: boolean;
  viewData?: IViewData | null;
  source?: string | null;
}

export const TOPIC_USER = 'user';
